'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var phone = exports.phone = {
  ldi: '0333 358 3441',
  ndi: '0333 358 3441',
  sdi: '0333 358 3441',
  cfy: '0333 358 3441',
  fdi: '0333 358 3441',
  advisor: '0843 504 2020',
  network: '0333 323 2615',
  products: '0333 358 3441',
  office: '0333 323 1328',
  complaint: '01733 207960',
  claims: {
    ndi: '0345 600 0676'
  },
  broker: '01733 907 402'
};
var social = exports.social = {
  facebook: 'WeAreMarmalade',
  twitter: 'wearemarmalade',
  googlePlus: '113955570060423387353',
  youtube: 'WeAreMarmalade01'
};
var email = exports.email = {
  ldi: 'learneradmin@wearemarmalade.co.uk',
  ndi: 'newdriveradmin@wearemarmalade.co.uk',
  sdi: 'studentdriver@wearemarmalade.co.uk',
  cfy: 'carsadmin@wearemarmalade.co.uk',
  fdi: 'familycar@marmalade.co.uk',
  general: 'enquiries@marmalade.co.uk',
  broker: 'broker@marmalade.co.uk'
};
var address = exports.address = ['Marmalade House', 'Alpha Business Centre', 'Mallard Road', 'Bretton', 'Peterborough', 'PE3 8AF', 'United Kingdom'];
var openingHours = exports.openingHours = {
  sunday: 'closed',
  monday: {
    open: 9,
    close: 18.5
  },
  tuesday: {
    open: 9,
    close: 18.5
  },
  wednesday: {
    open: 9,
    close: 18.5
  },
  thursday: {
    open: 9,
    close: 18.5
  },
  friday: {
    open: 9,
    close: 17.5
  },
  saturday: {
    open: 9,
    close: 15
  }
};